module.exports = __webpack_public_path__ + "static/superoffice-026701431296a17e0bb3dc546c0e46da.png";